__turbopack_context__.v({
  "label": "site-menu-module-scss-module__Q9xING__label",
  "link": "site-menu-module-scss-module__Q9xING__link",
  "logo": "site-menu-module-scss-module__Q9xING__logo",
  "note": "site-menu-module-scss-module__Q9xING__note",
  "panel": "site-menu-module-scss-module__Q9xING__panel",
  "primary": "site-menu-module-scss-module__Q9xING__primary",
  "secondary": "site-menu-module-scss-module__Q9xING__secondary",
  "small": "site-menu-module-scss-module__Q9xING__small",
  "top": "site-menu-module-scss-module__Q9xING__top",
});
